<template>
    <div>
        <div class="mb20">
            <a-popconfirm title="确认处理选中项?" @confirm="() => handleSelect('opt')">
                <a-button type="primary">处理</a-button>
            </a-popconfirm>
            <a-popconfirm title="确认删除选中项?" @confirm="() => handleSelect('del')">
                <a-button type="primary" style="margin-left:20px;">删除</a-button>
            </a-popconfirm>
        </div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:'checkbox'}"
            :pagination="false" :loading="tloading" rowKey="messageid" @change="handleTableChange">
            <!-- 报文 -->
            <template slot="readParams" slot-scope="text">
                <!-- <a-icon style="color:#1890ff;" size="large" type="file-text" @click="handleParams(text)" /> -->
                <a-button type="link"  @click="handleParams(text)">{{text}} </a-button>
            </template>
            <template slot="remarks" slot-scope="record">
                <a-input type="text" :disabled="selectedRowKeys.indexOf(record.messageid) == -1" value="" v-model="record.comments"></a-input>
            </template>
        </a-table>
        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

        <a-modal v-model="modalVisible" title="详情" @ok="handleOk">
            <json-viewer :value="currentRequest" :expand-depth=5 copyable boxed sort></json-viewer>
        </a-modal>
    </div>
</template>
<script>
import JsonViewer from "vue-json-viewer"

let pagination ={
    page:1,
    pageSize:10,
    total:0
};

const statusMap = {
    1: '主线程处理异常',
    2: '子线程处理异常',
    3: '定时任务处理异常',
    4: '后台页面手工执行异常',
};

const columns = [
    { 
        title: 'ID',
        dataIndex: 'messageid',
        align:'center',
        width:120,
    },
    { 
        title: '报文名称', 
        dataIndex: 'servicename',
        align:'center',
        width:200, 
    },
    {
        title: '报文',
        dataIndex: 'message', 
        align:'center',
        scopedSlots: { customRender: 'readParams' },
        ellipsis:true,
        width:200
    },
    {
        title: '处理状态', 
        dataIndex: 'checkstatus',
        align:'center',
        customRender:(text) => { return  statusMap[text]},
        width:200,
    },
    {
        title: '错误原因', 
        dataIndex: 'errorreason', 
        scopedSlots: { customRender: 'readParams' },
        ellipsis:true,
        align:'center',
        width:200
    },
    { 
        title: '创建时间', 
        dataIndex: 'receivemessagetime',
        align:'center',
        width:200 
    },
    { 
        title: '更新时间', 
        dataIndex: 'updatetime',
        align:'center',
        width:200
    },
    {
        title: "操作备注",
        scopedSlots: { customRender: 'remarks' },
        align:'center',
        width:200,
        fixed:'right',
    }

];

export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            ordercoloum:'total',
            orderstr:'desc',
            searchP:{},
            platforms:[],
            selectedRowKeys: [],
            queryType:'',
            opreateType:'',
            delType:'',
            modalVisible:false,
            currentRequest:'',
            statusMap
        };
    },
    methods: {
        handleParams(item){
            this.currentRequest = item;
            this.modalVisible = true;
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        handleOk(){
            this.modalVisible = false;
        },
        handleSelect(type){
            let that = this;

            if(that.selectedRowKeys.length == 0){
                that.message.warn('请勾选！')
                return
            }
            let messageids = that.selectedRowKeys.join(',');
            let operatecomments = "";
            let comments = [];
            let is_passed = true;
            that.selectedRowKeys.forEach(element => {
                let cItem = that.tableData.filter((cc)=>{ return cc.messageid == element });
                if(cItem.length > 0){
                    if(cItem[0].comments){
                        comments.push(cItem[0].comments);
                    }
                    else{
                        that.message.warn('请填写所有选中的操作备注！')
                        is_passed = false;
                        return false;
                    }
                }
                else{
                    that.message.warn('请填写所有选中的操作备注！')
                    is_passed = false;
                    return false;
                }
            });
            if(!is_passed){
                return;
            }
            operatecomments = comments.join(',');
            let params = {
                messageids,
                operatecomments,
                urlparams:false
            };
            that.$store.dispatch({
                type: type == 'opt' ? that.opreateType : that.delType,
                params:params
            }).then(()=>{
                that.getAppSumData()
            }).catch(() => {

            })
        },

        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.ordercoloum = sorter.field ;
                this.orderstr = sorter.order.replace('end','');
            }
            else{
                this.ordercoloum = '';
                this.orderstr = '';
            }

            this.getAppSumData();
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },

        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                timeout:30000,
                urlparams:false
            };
            that.$store.dispatch({
                type: that.queryType,
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.tableData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            let versionStr = this.searchP.version == 'V5.0' ? 'v5' : '';
            this.queryType = "messageProcessingModel/" + this.searchP.processtype + "query" + versionStr;
            this.opreateType = "messageProcessingModel/" + this.searchP.processtype + "operate" + versionStr;
            this.delType = "messageProcessingModel/" + this.searchP.processtype + "del" + versionStr;

            this.pagination.page = 1;
            this.getAppSumData();
        },
    },

    components:{
        JsonViewer
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

